import InstalacaoOpcao from "@/views/Instalacao/Opcoes.vue";
import InstalacaoPassoAPassoA3SafeIDPresencial from "@/views/Instalacao/PassoAPassoA3SafeIDPresencial.vue";
import InstalacaoPassoAPassoA3SafeIDVideoconferencia from "@/views/Instalacao/PassoAPassoA3SafeIDVideoconferencia.vue";

export default [
	{
		path: "/suporte/instalacao/a3-safe-id",
		name: "a3-safe-id",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Safe ID",
					href: "/suporte/instalacao/a3-safe-id",
				},
			],
			title: "Instalação - A3 Safe ID",
			description:
				"Para instalação do seu Certificado Digital SPC Brasil selecione o tipo de emissão.​",
			warning: "Este modelo de certificado não é compatível com outros sistemas operacionais (macOS e Linux).",
			cards: [
				{
					icon: "/certificacaodigital/images/instalacao/presencial.svg",
					title: "Presencial",
					content: "Instale o Certificado Digital SPC Brasil que foi emitido presencialmente.",
					href: "a3-safe-id/presencial",
				},
				{
					icon: "/certificacaodigital/images/instalacao/video_conferencia.svg",
					title: "Videoconferência",
					content: "Instale o Certificado Digital SPC Brasil que foi solicitado através da videoconferência.",
					href: "a3-safe-id/videoconferencia",
				},
			],
		},
		component: InstalacaoOpcao,
	},
	{
		path: "/suporte/instalacao/a3-safe-id/presencial",
		name: "a3-safe-id-presencial",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Safe ID",
					href: "/suporte/instalacao/a3-safe-id",
				},
				{
					label: "emissão presencial",
					href: "/suporte/instalacao/a3-safe-id/presencial",
				},
			],
			title: "A3 Safe ID",
			subtitle: "Emissão Presencial",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do instalador e o manual de instruções.",
			warning: "Este modelo de certificado não é compatível com outros sistemas operacionais (macOS e Linux).",
		},
		component: InstalacaoPassoAPassoA3SafeIDPresencial,
	},
	{
		path: "/suporte/instalacao/a3-safe-id/videoconferencia",
		name: "a3-safe-id-videoconferencia",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Safe ID",
					href: "/suporte/instalacao/a3-safe-id",
				},
				{
					label: "videoconferência",
					href: "/suporte/instalacao/a3-safe-id/videoconferencia",
				},
			],
			title: "A3 Safe ID",
			subtitle: "Videoconferência - Windows",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do instalador e o manual de instruções.",
			warning: "Este modelo de certificado não é compatível com outros sistemas operacionais (macOS e Linux).",
		},
		component: InstalacaoPassoAPassoA3SafeIDVideoconferencia,
	},
];
